import { useState, useEffect, useContext } from 'react'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const useGeoPosition = () => {
  const { locale = {} } = useContext(BootstrapDataContext)
  const [longitude, setLongitude] = useState(
    locale.longitude ? locale.longitude : ''
  )
  const [latitude, setLatitude] = useState(
    locale.latitude ? locale.latitude : ''
  )

  const onSuccess = ({ coords }) => {
    setLongitude(coords.longitude)
    setLatitude(coords.latitude)
  }
  const onError = () => {
    // TODO: fail silently or log error
  }
  useEffect(() => {
    const geo = navigator.geolocation
    if (!geo) {
      // TODO: potentially log error
      return
    }
    geo.getCurrentPosition(onSuccess, onError)
  }, [])

  return { longitude, latitude }
}

export default useGeoPosition
